import { Card, Col } from 'antd';
import styled from 'styled-components';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';

export const MapAndResourcesCol = styled(Col)`
  height: calc(100vh - 170px);
  ${cssMediaBreakpoints.mobileOrTablet} {
    height: auto;
  }
`;

export const DetailsCard = styled(Card)`
  margin-top: 12px;
`;
